<script setup lang="ts">
const props = defineProps({
  storyId: {
    type: String,
    required: true,
  },
  authorId: {
    type: String,
    required: true,
  },
  likeCount: {
    type: Number,
  },
})
const { checkLiked } = useLike()
const { incrementLikeCount } = useStoryBase()
const { addLikedStory } = useUserBase()
const { $tracker } = useNuxtApp()

const isLiked = ref(false)
const isPressed = ref(false)

function like() {
  incrementLikeCount(props.storyId, 1)
  addLikedStory(props.storyId, props.authorId)
  isLiked.value = true
  isPressed.value = true
  document.getElementById('likeAnimation')!.src = '/images/like.gif'
  $tracker('like_story', { id: props.storyId })
}

onMounted(async () => {
  const likedRecord = await checkLiked('stories', props.storyId)
  isLiked.value = !!likedRecord
})
</script>

<template>
  <ui-button
    v-check-login="like"
    class="flex flex-row items-center justify-center flex-1 touch-manipulation"
    variant="ghost"
  >
    <div class="relative w-[22px] h-[22px]">
      <img id="likeAnimation" src="/images/like.gif" class="w-[22px] scale-[2.5] absolute bottom-[2px]" :class="{ 'opacity-0': !isPressed }">
      <i
        v-if="isLiked"
        i-ph-heart-fill
        class="text-[22px] !text-[#EF4444]"
      />
      <i
        v-else
        i-ph-heart
        class="text-[22px] !text-neutral-600"
      />
    </div>
    <span class="ml-1 text-neutral-600">{{ likeCount }}</span>
  </ui-button>
</template>
